export default __webpack_public_path__ + "static/media/rss.a123b741.svg";